function ArrowDownIcon2({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="11"
      viewBox="0 0 15 11"
      fill="none"
      {...props}
    >
      <path
        d="M1.21794 3L7.50005 8.76465L13.7821 3L15 4.11767L7.50005 11L-6.01672e-07 4.11768L1.21794 3Z"
        fill="white"
      />
    </svg>
  );
}
export default ArrowDownIcon2;
